import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { CHECK_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const CheckRoundedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={CHECK_ROUNDED_GLYPH} />;
